// extracted by mini-css-extract-plugin
export var button = "_l7-2";
export var card = "_l7-0";
export var closeButtonContainer = "_l7-3";
export var iconContainer = "_l7-1";